function Square({value, index, onMouseDown, onTouchStart}) {
    return (<div className={`square ${value === null ? 'is-empty' : ''}`}>
        <button onDragStart={() => false} onMouseDown={onMouseDown} onTouchStart={onTouchStart} data-index={index} dava-value={value}>{value}</button>
    </div>);
}

export default Square;